export default "__VITE_ASSET__DiOq7YyN__"